/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalHistoryAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2SearchHistory from 'DesignSystem/Svgs/Tysiav2SearchHistory/index'



/** @type {import('Simple/types.js').View} */
export default function MedicalHistoryAction({
  children,
  viewPath = "/DesignSystem/ProfileActions/MedicalHistoryAction",
  type = "secondary"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  type
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type={type}
 title="Medical history"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2SearchHistory
{...childProps}
  viewPath={`${viewPath}/Tysiav2SearchHistory`}
 width={type === 'ghost' ? "14px" : "12px"}
 height={type === 'ghost' ? "14px" : "12px"}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}